import { useNavigate } from "react-router-dom";
import { ShieldCheck, Users } from "@phosphor-icons/react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_admin-dashboard-flux/artifacts/ef1ryefo_The%20Gowda%E2%80%99s%20Group.png";
const BG_URL = "https://static.prod-images.emergentagent.com/jobs/d7f48274-665e-4130-b577-6d1e990ded15/images/269834a82af8a33b2b6d1aa6341da49cc1cf70d7f6d6225aa46801ec3fb58b8a.png";

export default function LandingPage() {
  const navigate = useNavigate();

  return (
    <div
      className="min-h-screen flex items-center justify-center relative"
      style={{ background: `url(${BG_URL}) center/cover no-repeat, #0A0A0A` }}
      data-testid="landing-page"
    >
      <div className="absolute inset-0 bg-[#0A0A0A]/75" />
      <div className="relative z-10 w-full max-w-lg mx-4 text-center">
        <img src={LOGO_URL} alt="VeloxAlgoTech LLP" className="w-20 h-20 mx-auto mb-4" />
        <h1
          className="text-3xl md:text-4xl font-black tracking-tight mb-1"
          style={{ fontFamily: "'Cabinet Grotesk', sans-serif", letterSpacing: "0.06em" }}
          data-testid="brand-name-landing"
        >
          <span style={{ color: '#00b4d8' }}>Velox</span>
          <span className="text-white">AlgoTech</span>
        </h1>
        <p className="text-sm text-[#A1A1AA] mb-10">Affiliate Platform</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {/* Admin Card */}
          <button
            onClick={() => navigate("/login")}
            data-testid="enter-admin"
            className="group p-6 rounded-xl border border-white/10 bg-[#121212]/80 backdrop-blur-md hover:border-[#00E5FF]/40 hover:shadow-[0_0_30px_rgba(0,229,255,0.1)] transition-all duration-300 flex flex-col items-center justify-center min-h-[180px]"
          >
            <div className="w-14 h-14 rounded-lg bg-[#00E5FF]/10 flex items-center justify-center mb-4 group-hover:bg-[#00E5FF]/20 transition-colors">
              <ShieldCheck size={28} weight="duotone" className="text-[#00E5FF]" />
            </div>
            <h2 className="text-lg font-bold text-white" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>
              Admin Dashboard
            </h2>
          </button>

          {/* Affiliate Card */}
          <button
            onClick={() => navigate("/affiliate/login")}
            data-testid="enter-affiliate"
            className="group p-6 rounded-xl border border-white/10 bg-[#121212]/80 backdrop-blur-md hover:border-blue-500/40 hover:shadow-[0_0_30px_rgba(59,130,246,0.1)] transition-all duration-300 flex flex-col items-center justify-center min-h-[180px]"
          >
            <div className="w-14 h-14 rounded-lg bg-blue-500/10 flex items-center justify-center mb-4 group-hover:bg-blue-500/20 transition-colors">
              <Users size={28} weight="duotone" className="text-blue-500" />
            </div>
            <h2 className="text-lg font-bold text-white" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>
              Affiliate Dashboard
            </h2>
          </button>
        </div>
      </div>
    </div>
  );
}
